import "./NavBar.css";

// Canm customise these in other projects. No point being props as will always be the same.
import logo from "../../Images/logo.svg";
import {Link, useNavigate} from "react-router-dom";
import {Box, Menu, MenuItem, Stack, styled, Typography} from "@mui/material";
import {useState} from "react";
import {TitleLogo} from "../../Util/styledComponents";
import {capitalise, useCheckMobileScreen} from "../../Util/util";
import {SectionType, subjectsForType} from "../../Util/constants";
import {signOut} from "firebase/auth";
import {auth} from "../../Util/firebaseConfig";
import {LogoutRounded} from "@mui/icons-material";
import IconButtonPop from "../IconButtonPop";


const BurgerMenu = styled(Box)<{open?: boolean}>(({open}) => ({
    "flex": 1,
    "margin-left": "20px",

    "@media only screen and (max-width: 1093px)": {
        "#burger": {
            display: "flex",
        },
        ".innerStack": {
            "flexDirection": "column",
            "margin": 0,
            "a": {
                "margin": 0,
                "marginTop": 5,
            },
            "button": {
                "margin": 0,
                "marginTop": 10,
            },
        },
        "#link-holder": {
            position: "absolute",
            background: "white",
            display: "flex",
            flexDirection: "column",
            padding: "20px",
            fontSize: "1.2em",
            left: 0,
            transition: "all 400ms ease-in-out",
            transform: `translateX(${open ? 0 : "100%"})`,
            top: "49px",
            width: "100%",
            height: "45vh",
            boxShadow: "0px 4px 8px -4px rgba(163,163,163,0.59)",
            justifyContent: "space-around",
        },
    },
}));

const Burger = styled(Box)<{open?: boolean}>(({theme, open}) => ({
    "top": "5%",
    "float": "right",
    "display": "none",
    "flexDirection": "column",
    "justifyContent": "space-around",
    "width": "2rem",
    "height": "2rem",
    "background": "transparent",
    "border": "none",
    "cursor": "pointer",
    "padding": 0,
    "zIndex": 10,

    "&:focus": {
        outline: "none",
    },

    "div": {
        "width": "2rem",
        "height": "0.25rem",
        "backgroundColor": (theme as any).palette.primary.main,
        "borderRadius": "10px",
        "transition": "all 0.3s linear",
        "position": "relative",
        "transformOrigin": "1px",

        ":first-child": {
            transform: open ? "rotate(45deg)" : "rotate(0)",
        },

        ":nth-child(2)": {
            opacity: open ? "0" : "1",
            transform: open ? "translateX(20px)" : "translateX(0)",
        },

        ":nth-child(3)": {
            transform: open ? "rotate(-45deg)" : "rotate(0)",
        },
    },
}));

const NavBarLink = styled(Link)(({theme}) => ({
    "textDecoration": "none",
    "color": theme.palette.secondary.main,
    "paddingLeft": theme.spacing(2),
    "paddingRight": theme.spacing(2),
    "&:hover": {
        textDecoration: "underline",
    }}));

export const NAVBARHEIGHT = "60px";

// A top-level nav link (News / Learn) with a subject dropdown. Clicking the word
// navigates to the section landing; hovering (desktop) or the caret reveals the
// subject sub-pages.
function NavDropdown({label, base, onNavigate}:{label: string, base: SectionType, onNavigate: () => void}) {
    const navigate = useNavigate();
    const [anchor, setAnchor] = useState<null | HTMLElement>(null);
    const close = () => setAnchor(null);
    const go = (path: string) => {
        close();
        onNavigate();
        navigate(path);
    };

    return (
        <Box onMouseLeave={close} sx={{display: "inline-flex", alignItems: "center"}}>
            <NavBarLink to={`/${base}`} onMouseEnter={(e) => setAnchor(e.currentTarget)} onClick={() => {
                close();
                onNavigate();
            }}>{label}</NavBarLink>
            <Menu
                anchorEl={anchor}
                open={Boolean(anchor)}
                onClose={close}
                anchorOrigin={{vertical: "bottom", horizontal: "left"}}
                transformOrigin={{vertical: "top", horizontal: "left"}}
                MenuListProps={{onMouseLeave: close}}
                disableScrollLock
            >
                {subjectsForType(base).map((subject) => (
                    <MenuItem key={subject} onClick={() => go(`/${base}/${subject}`)}>{capitalise(subject)}</MenuItem>
                ))}
            </Menu>
        </Box>
    );
}

export default function NavBar() {
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);
    const isMobile = useCheckMobileScreen();

    // const [anchorEl, setAnchorEl] = React.useState(null);

    // function handleClick(event: any) {
    //     if (anchorEl !== event.currentTarget) {
    //         setAnchorEl(event.currentTarget);
    //     }
    // }

    // function handleClose() {
    //     setAnchorEl(null);
    // }


    // All staff can see jobs, but maybe add as a user permission
    const fSignOut = async () => {
        await signOut(auth); navigate("/login");
    };

    return (
        <>
            <div className="navbar" style={{height: NAVBARHEIGHT}}>
                <div className="inner">
                    <table onClick={() => {
                        navigate("/");
                        setMenuOpen(false);
                    }} style={{cursor: "pointer"}}>
                        <tbody>
                            <tr>
                                <td>
                                    <TitleLogo src={logo as any} alt="Scimos main logo, an atom."/>
                                </td>
                                <td>
                                    {isMobile || <Typography ml={2} pt={0.6} color="#38383b !important">Science For Everyone</Typography>}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <BurgerMenu open={menuOpen}>
                        <Burger id={"burger"} open={menuOpen} onClick={() => setMenuOpen((m) => !m)}><div></div><div></div><div></div></Burger>
                        <Stack direction={isMobile ? "column" : "row"} id={"link-holder"} flex={1} justifyContent={"end"} mr={"5vw"} alignItems={"center"}>
                            <Stack className="innerStack" direction={"row"} flexWrap={"wrap"}>
                                <NavDropdown key={"news"} label={"News"} base={"news"} onNavigate={() => setMenuOpen(false)}/>
                                <NavDropdown key={"learn"} label={"Learn"} base={"learn"} onNavigate={() => setMenuOpen(false)}/>
                                {auth.currentUser && <IconButtonPop responsive={false} title={"Sign out"} key={"sign-out"} onClick={fSignOut}><LogoutRounded/></IconButtonPop>}
                            </Stack>
                        </Stack>
                    </BurgerMenu>
                </div>
            </div>
        </>
    );
}
